import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledAgendaLoaderBody = styled(Flexbox)(
    ({theme: {palette, spacing}}) => css`
        background-color: ${palette.neutral['white']};
        padding: ${spacing * 4}px;
    `
)

export const StyledAgendaLoaderCalendarGrid = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: ${spacing * 2}px;
    `
)
